<template>
  <div>
    <vue-good-table
      :columns="columns"
      :rows="order.items"
    >
      <template slot="table-row" slot-scope="props">
        <span v-if="props.column.field == 'product.sku'">
          <router-link :to="'/products/' + props.row.product.id">{{props.row.product.sku}}</router-link>
        </span>
        <span v-else>
          {{props.formattedRow[props.column.field]}}
        </span>
      </template>    
    </vue-good-table>
  </div>
</template>

<script>
import { VueGoodTable } from 'vue-good-table'
export default {
  name: 'items-tab',

  components: {
    VueGoodTable
  },

  props: {
    order: Object,
  },

  data() {
    return {
      columns: [
        {
          label: 'SKU',
          field: 'product.sku',
        },
        {
          label: 'Description',
          field: 'product.name',
        },
        {
          label: 'Units',
          field: r => r.package_id == 1 ? 'CS' : 'EA',
        },
        {
          label: 'Qty',
          field: 'qty',
        },
        {
          label: 'Qty Received',
          field: 'qty_received',
        }
      ]
    }
  }
}
</script>
